// Enterprise standard page header — see /app/memory/DESIGN_SYSTEM.md §8
import { DotsThree } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

export const PageHeader = ({ title, eyebrow, description, primary, secondary, menuItems, className, testid }) => (
  <header className={cn('flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3', className)} data-testid={testid}>
    <div className="min-w-0 lg:max-w-3xl">
      {eyebrow && <div className="mb-1" data-testid={testid ? `${testid}-eyebrow` : undefined}>{eyebrow}</div>}
      <h1 className="text-2xl font-bold tracking-tight text-zinc-900">{title}</h1>
      {description && <p className="text-sm text-zinc-600 mt-1">{description}</p>}
    </div>
    <div className="flex items-center gap-2 shrink-0 flex-wrap">
      {secondary}
      {menuItems && menuItems.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="icon" aria-label="その他の操作" data-testid={testid ? `${testid}-menu` : 'page-header-menu'}>
              <DotsThree size={18} weight="bold" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="bg-white">
            {menuItems.map((m, i) => (
              <DropdownMenuItem
                key={i}
                onClick={m.onClick}
                data-testid={m.testid}
                className={cn('gap-2', m.destructive && 'text-rose-600 focus:text-rose-600')}
              >
                {m.icon}
                {m.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      {primary}
    </div>
  </header>
);
